import request from '@/utils/request'

// Get shared spot list
export function listSharedSpots(query) {
  return request({
    url: '/parking/sharedspot/user/listMobile',
    method: 'get',
    params: query
  })
}

// Post shared spot list
export function selectMySharedSpot(query) {
  return request({
    url: '/parking/sharedspot/selectMySharedSpot',
    method: 'post',
    data: query
  })
}

// Get shared spot details
export function getSharedSpot(id) {
  if (!id) {
    console.warn('getSharedSpot called with null or undefined id');
    return Promise.reject(new Error('Shared spot ID is required'));
  }
  return request({
    url: '/parking/sharedspot/user/detail/' + id,
    method: 'get'
  })
}

// Add new shared spot
export function addSharedSpot(data) {
  return request({
    url: '/parking/sharedspot/addByMobile',
    method: 'post',
    data: data
  })
}

// Update shared spot
export function updateSharedSpot(data) {
  return request({
    url: '/parking/sharedspot',
    method: 'put',
    data: data
  })
}

// Delete shared spot
export function deleteSharedSpot(id) {
  return request({
    url: '/parking/sharedspot/' + id,
    method: 'delete'
  })
}
